import { FormattedInputBuilder } from './common';

const blocks = {
  SSSS: {
    mask: '****',
  },
  MMMM: {
    mask: '0000',
  },
  EE: {
    mask: '00',
  },
};

const shouldPreventChar = (char: string) => !/[a-z0-9]/gi.test(char);
export const HesCode = FormattedInputBuilder({
  mask: 'SSSS-MMMM-EE',
  blocks,
  shouldPreventChar,
  name: 'hesCode',
});
export default HesCode;
